import { render, staticRenderFns } from "./CreateBookingButton.vue?vue&type=template&id=0f8ce6ba&"
import script from "./CreateBookingButton.vue?vue&type=script&lang=js&"
export * from "./CreateBookingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports